import { createFileRoute } from "@tanstack/react-router";

import { AdminWorkspacesPage } from "@/components/admin/AdminWorkspacesPage";

export const Route = createFileRoute("/administrator/workspaces")({
  head: () => ({ meta: [{ title: "Workspaces · GENRL Admin" }] }),
  component: AdminWorkspacesPage,
});
